// A selectable item to be used in a list of dropdown items.
// @flow
import React, { PureComponent } from 'react';
import { MenuItem } from 'material-ui/Menu';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

type Props = {
    image: string,
    text: string,
    query?: string,
    selected?: boolean
};

export default class SelectableItem extends PureComponent<Props> {
    static defaultProps = {
        selected: false,
        query: ''
    };

    render() {
        const { image, query, selected, text } = this.props;
        const matches = match(text, query);
        const parts = parse(text, matches);

        return (
            <MenuItem selected={selected} component="div">
                <img alt="" src={image} />
                <div>
                    {parts.map((part: text, index: number) => {
                        const displayText =
                            part.text.length > 30
                                ? part.text.slice(0, 27).trim() + '...'
                                : part.text;

                        return part.highlight ? (
                            <span
                                key={String(index)}
                                style={{ fontWeight: 500 }}
                            >
                                {displayText}
                            </span>
                        ) : (
                            <strong
                                key={String(index)}
                                style={{ fontWeight: 300 }}
                            >
                                {displayText}
                            </strong>
                        );
                    })}
                </div>
            </MenuItem>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/common/dropdown/SelectableItem.jsx